import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './logo.css';
import logo from '../../assets/logo.png';

const Logo: React.FC<{isFooter?: boolean}> = ({isFooter = false}) => {
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    // Trigger animation on mount
    setHasAnimated(true);
  }, []);

  return (
    <div className={`logo-section ${hasAnimated ? 'animated' : ''} ${isFooter ? 'footer-logo' : ''}`}>
      <Link to="/" className="logo">
        <div className="logo-wrapper">
          <div className="logo-glow-ring"></div>
          <div className="logo-particles">
            <span className="particle particle-1"></span>
            <span className="particle particle-2"></span>
            <span className="particle particle-3"></span>
            <span className="particle particle-4"></span>
          </div>
          <img src={logo} alt="irony-X.com" className="logo-img" /> 
        </div>
      </Link>
    </div>
  );
};

export default Logo;
